
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/travel/whatsapp",
      function () {
        return require("private-next-pages/industry/travel/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/travel/whatsapp"])
      });
    }
  